export class PerformanceDto {

    constructor(id, band, stage, timeFrame) {
        this.id = id;
        this.band = band;
        this.stage = stage;
        this.timeFrame = timeFrame;
    };

};